import React from "react";

import Resume from "../BryanDeloesteResume2017.pdf";
import styles from "./footer.module.css";

export default () => (
  <footer>
    <div className={styles.footer} />
    <nav>
      <ul>
        <li>
          <a href="mailto:bryandeloeste@gmail.com">Email</a>
        </li>
        <li>
          <a href="https://www.instagram.com/gosu.delo">@gosu.delo</a>
        </li>
        <li>
          <a href="https://www.github.com/bdeloeste">Github</a>
        </li>
        <li>
          <a href={Resume}>Resume</a>
        </li>
      </ul>
    </nav>
  </footer>
);



// WEBPACK FOOTER //
// ./src/components/footer.js